import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTenders } from '~src/services/api';
import { DbTender } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { useProject } from './useProject';

interface UseTenderFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
}
export const useTenders = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
  }: UseTenderFoldersParams = {},
  queryConfig: QueryConfig<DbTender[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const archiveSettings = useArchiveSettings();
  const projectQuery = useProject();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on &&
    (projectQuery?.data?.is_tender_manager || projectQuery?.data?.is_superuser);

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenders = useQuery<DbTender[], AxiosError>(
    [
      'tenders',
      {
        projectId: String(projectId),
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
      },
    ],
    loadTenders,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId && isTenderingOn,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenders;
};
